<!-- Previsione attuale -->
<div *ngIf="type === 'dashboard'">
    <div *ngIf="loading.value" class="text-center" style="height: 255px;">
        <ngx-skeleton-loader count="5" [theme]="{height: '30px'}"></ngx-skeleton-loader>
    </div>
    <div *ngIf="!loading.value">
        <ng-container *ngIf="weather.date.length; else bloccoElse">
            <div class="row">
                <div class="col-lg-6 text-center">
                    <span class="temperature">
                        {{ weather.temperature}}°
                    </span><br>
                    {{ weather.date | date: 'dd MMMM yyyy'}}
                </div>
                <div class="col-lg-6 text-center">
                    <img *ngIf="weather.icon" src="/assets/images/weather/{{ weather.icon }}.png" width="100" /><br>
                    {{ weather.description }}
                </div>
            </div>
            <div class="row">
                <hr style="width: 100%;color: #FFF;">
            </div>
            <div class="row">
                <div class="col-lg-6 text-center">
                    <mat-card-title style="display: flex; align-items: center; justify-content: center;">
                        <i-tabler name="cloud-filled" style="margin-right: 5px;"></i-tabler>
                        <div>Nuvolosità</div>
                    </mat-card-title>
                    {{ weather.cloud_coverage}} %<br>
                </div>
                <div class="col-lg-6 text-center">
                    <mat-card-title style="display: flex; align-items: center; justify-content: center;">
                        <i-tabler name="solar-panel" style="margin-right: 5px;"></i-tabler>
                        <div>Irradianza</div>
                    </mat-card-title>
                    {{ weather.direct_radiation}} W/m<sup>2</sup>
                </div>
            </div>
            <mat-card-footer class="row text-center d-block">
                <i-tabler name="{{ weather.sentiment}}" class="icon-35 {{weather.sentimentColor}}"></i-tabler>
                <div>
                    {{weather.sentimentMessage}}
                </div>
            </mat-card-footer>
        </ng-container>
    </div>
</div>


<!-- Previsione attuale mini -->
<div *ngIf="type === 'sideBar'" style="color: #FFF;">
    <div *ngIf="loading.value" class="text-center">
        <ngx-skeleton-loader count="3" appearance="circle"></ngx-skeleton-loader>
    </div>
    <div *ngIf="!loading.value">
        <ng-container *ngIf="weather.date.length; else bloccoElse">
            <div class="head-mini">
                {{ _cityName }}
            </div>
            {{ weather.date | date: 'dd MMMM yyyy'}}
            <div class="row">
                <div class="col-lg-6 text-center">
                    <span class="temperature-mini">
                        {{ weather.temperature}}°
                    </span>
                </div>
                <div class="col-lg-6 text-center">
                    <img *ngIf="weather.icon" src="/assets/images/weather/{{ weather.icon }}.png"
                        style="width: 55px" /><br>
                    {{ weather.description }}
                </div>
            </div>
        </ng-container>
    </div>
</div>


<!-- Forecast - Previsioni settimana -->
<div *ngIf="type === 'forecast'">
    <div *ngIf="loading.value" class="text-center" style="height: 255px;">
        <ngx-skeleton-loader count="5" [theme]="{height: '30px'}" animation="pulse"></ngx-skeleton-loader>
    </div>

    <div *ngIf="!loading.value">
        <ng-container *ngIf="dailyForecasts.length; else bloccoElse">
            <div class="row" style="padding: 26px 21px;">
                <div *ngFor="let forecast of dailyForecasts" class="daily-box">
                    <mat-card-content class="content-card">
                        <span class="day-label">{{ forecast.day | date: ' cccc \n dd '}}</span>
                        <div class="text-center" style="display: block; margin: 0 auto;">
                            <span style="height: 60px;display: block;">
                                <img src="/assets/images/weather/{{ forecast.icon }}.png" style="width: 55px;" /><br>
                            </span>
                            <span class="forecast-description">
                                {{ forecast.description }}
                            </span>
                        </div>
                    </mat-card-content>
                </div>
                <div *ngFor="let forecast of dailyForecasts" style="width: 14%; text-align: center;">
                    <mat-card-footer>
                        <div class="text-center min-max">
                            <span class="text-center" style="display: block;margin: 0 auto;">
                                Min<br>
                                {{ forecast.minTemperature}}°
                            </span>
                            <span class="text-center max">
                                Max<br>
                                {{ forecast.maxTemperature}}°
                            </span>
                        </div>
                    </mat-card-footer>
                </div>
            </div>
        </ng-container>
    </div>
</div>


<!-- Forecast - Previsioni orarie giornaliera -->
<div *ngIf="type === 'hourly'">

    <div *ngIf="loading.value" class="text-center p-y-20" style="height: 255px; padding: 26px 21px; margin: 0 auto;">
        <ngx-skeleton-loader count="5" [theme]="{height: '30px'}" animation="pulse"></ngx-skeleton-loader>
    </div>

    <div *ngIf="!loading.value">
        <ng-container *ngIf="hourlyForecasts.length; else bloccoElse">
            <div class="row" style="padding: 26px 21px; margin: 0 auto;">
                <div *ngFor="let forecast of hourlyForecasts; let i = index" class="hourly-box">
                    <mat-card-content class="content-card"
                        [ngStyle]="{'background-color': i % 2 === 0 ? '' : 'lightgray'}">
                        <span class="day-label">{{ forecast.time }}:00</span><br><br>
                        <div class="text-center" style="display: block; margin: 0 auto;">
                            <span style="height: 60px;display: block;">
                                <img src="/assets/images/weather/{{ forecast.icon }}.png" style="width: 30px;" /><br>
                            </span>
                            <span class="forecast-description">
                                {{ forecast.temperature }}°
                                <!-- {{ forecast.description }} -->
                            </span>
                        </div>
                    </mat-card-content>
                </div>
            </div>
            <div *ngFor="let forecast of hourlyForecasts" style="width: 9%; text-align: center;">
                <mat-card-footer>
                    <div class="text-center min-max">
                        <span class="text-center" style="display: block;margin: 0 auto;">
                            <!-- {{ forecast.temperature }}° -->
                        </span>
                    </div>
                </mat-card-footer>
            </div>
        </ng-container>
    </div>
</div>

<ng-template #bloccoElse>
    <div class="col-12 text-center f-s-24 f-w-500 p-y-20">
        Dati meteo non ancora disponibili.
    </div>
</ng-template>
<ng-template #noData>
    <div class="col-12 text-center f-s-24 f-w-500 p-y-20">
        Dati meteo non ancora disponibili.
    </div>
</ng-template>